/** @typedef {import("../../api/types").Order} Order */
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {Alert, Container, Spinner} from "reactstrap";
import OrderForm from "./components/OrderForm";

/**
 * Changes an order that is still open or sent. The API says whether it can
 * (`available_actions` has "edit"), so a stale link to an order that has
 * moved on gets an explanation instead of a form that would be refused.
 */
const OrderEdit = () => {
    const {id} = useParams();
    const [order, setOrder] = useState(/** @type {Order|null} */ (null));
    const [status, setStatus] = useState(/** @type {"loading"|"ready"|"error"} */ ("loading"));

    useEffect(() => {
        const controller = new AbortController();
        setStatus("loading");
        setOrder(null);

        axios
            .get(`/os/api/service_orders/${encodeURIComponent(id)}/`, {signal: controller.signal})
            .then(({data}) => {
                setOrder(data);
                setStatus("ready");
            })
            .catch((err) => {
                if (!axios.isCancel(err)) setStatus("error");
            });

        return () => controller.abort();
    }, [id]);

    if (status === "loading") {
        return (
            <div className="text-center mt-5">
                <Spinner />
            </div>
        );
    }
    if (status === "error" || !order) {
        return (
            <Container className="mt-4" style={{maxWidth: 860}}>
                <Alert color="danger">Não foi possível carregar a ordem de serviço.</Alert>
            </Container>
        );
    }
    if (!order.available_actions?.includes("edit")) {
        return (
            <Container className="mt-4" style={{maxWidth: 860}}>
                <Alert color="warning">
                    A ordem de serviço nº {order.number} não pode mais ser editada.{" "}
                    <Link to={`/orders/${order.id}`}>Voltar para a ordem</Link>
                </Alert>
            </Container>
        );
    }
    return <OrderForm editing={order} />;
};

export default OrderEdit;
